import { useFormik } from "formik"
import PropTypes from "prop-types"
import React, { useEffect, useRef, useState } from "react"
import { Editor } from "react-draft-wysiwyg"
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css"
import { useLocation, useNavigate } from "react-router-dom"
import {
  Card,
  CardBody,
  Col,
  Container,
  FormFeedback,
  Input,
  Label,
  Row
} from "reactstrap"
import * as Yup from "yup"

import { stateToHTML } from 'draft-js-export-html'

import { ContentState, EditorState, convertFromHTML } from 'draft-js'

import Breadcrumbs from "components/Common/BreadcrumbTitle"

import CommonDialog from "components/Common/CommonDialog"

import {
  addTemplate,
  editTemplate,
  getEmailTemplate
} from "../../http/UAM/emailTemplate.helper";
import { useToast } from "ToastStore"
import { decryptedValue } from "common/utility"
import JoditEditor from "jodit-react"

const AddEmailTemplate = props => {
  const navigate = useNavigate()

  const location = useLocation()
  const pathnameSegments = location.pathname.split("/")
  const lastSegment = pathnameSegments[pathnameSegments.length - 1]

  document.title = `${lastSegment.toUpperCase()} Permission | FundLync`

  const urlParams = new URLSearchParams(window.location.search)
  const encodedId = urlParams.get("id")
  const decodedId = atob(encodedId)

  const [showCommonDialog, setShowCommonDialog] = useState({ isShow: false });
  const [templateList, setTemplateList] = useState({})
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [emailBody, setEmailBody] = useState('');
  const [editorError, setEditorError] = useState('');
  const [showViewTemplate, setShowViewTemplate] = useState(false);
  const [showEditTemplate, setShowEditTemplate] = useState(true);

  const { handleToastData } = useToast();
  const editor = useRef(null)
  useEffect(() => {
    if (lastSegment == "edit" || lastSegment == "view") {
      getEmailTemplate({ templateId: decodedId })
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 200) {
            setTemplateList(responseFromAPI.data)
            setEmailBody(responseFromAPI.data.emailBody);
            const contentBlock = convertFromHTML(responseFromAPI.data.emailBody);
            const contentState = ContentState.createFromBlockArray(contentBlock.contentBlocks);
            setEditorState(EditorState.createWithContent(contentState));
          }
        })
        .catch(error => { })
    }
    if (lastSegment == "view") {
      setShowViewTemplate(true)
      setShowEditTemplate(false)
    } else {
      setShowViewTemplate(false)
      setShowEditTemplate(true)
    }
  }, [])

  const handleEditorChange = (newEditorState) => {
    // Update the state with the new editor content
    setEditorState(newEditorState);
    setEditorError('');
  };


  // validation
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      emailType: (templateList.emailType) || "",
      subject: (templateList.subject) || "",
      // emailBody: (templateList.emailBody) || "",
    },
    validationSchema: Yup.object({
      emailType: Yup.string().required("Please Enter Email Type"),
      subject: Yup.string().required("Please Enter Email Subject"),
      // emailBody:  Yup.object().required("Ple")
    }),
    onSubmit: values => {

      const message = lastSegment == 'edit' ? 'Are you sure want to update template?' : 'Are you sure want to add template?'
      setShowCommonDialog({ isShow: true, message: message })


    },
  })

  const navigateBack = () => {
    const encryptedtemplate = btoa("email");
    const user = decryptedValue(localStorage.getItem("user"));
    navigate(`/${user.roleName}/email-template?temp=${encryptedtemplate}`)
  }

  const submiTemplates = () => {
    const { values } = validation
    if (emailBody === "") {
      setEditorError('Email Body is required.');
      return;
    }
    if (lastSegment == "edit") {
      const updateTemplate = {
        templateId: decodedId,
        emailType: values.emailType,
        subject: values.subject,
        emailBody: emailBody 
      }
      // update permission
      editTemplate(updateTemplate)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            const encryptedtemplate = btoa("email");
            handleToastData(responseFromAPI.message, "success")
            const user = decryptedValue(localStorage.getItem("user"));
            navigate(`/${user.roleName}/email-template?temp=${encryptedtemplate}`);
          }
        })
        .catch(error => { })
      validation.resetForm()
    } else {
      const newTemplate = {
        emailType: values.emailType,
        subject: values.subject,
        emailBody: emailBody
      }

      addTemplate(newTemplate)
        .then(responseFromAPI => {
          if (responseFromAPI.status && responseFromAPI.code == 201) {
            const encryptedtemplate = btoa("email");
            handleToastData(responseFromAPI.message, "success")
            const user = decryptedValue(localStorage.getItem("user"));
            navigate(`/${user.roleName}/email-template?temp=${encryptedtemplate}`);
          }
        })
        .catch(error => { })
      validation.resetForm()
    }
  }

  const dialogAction = (action, data) => {
    if (action == 1) {
      setShowCommonDialog({ isShow: false })
      submiTemplates()

    } else {

      setShowCommonDialog({ isShow: false })
    }
  }
  const config = {
    removeButtons: ['about'],
    showCharsCounter: false,
    showWordsCounter: false,
    showXPathInStatusbar: false,
  };
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs
            title={`${lastSegment.toUpperCase()} TEMPLATE`}
          />
          <Row className="vertical-scroll">
            <Col xs="12">
              <Card>
                <CardBody>
                  {showEditTemplate && <form
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row className="mb-4">
                      <Col sm={6} >
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Type *
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="emailType"
                          id="horizontal-email-Input"
                          placeholder="Enter Email Type"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.emailType || ""}
                          invalid={
                            validation.touched.emailType &&
                              validation.errors.emailType
                              ? true
                              : false
                          }
                        />
                        {validation.touched.emailType &&
                          validation.errors.emailType ? (
                          <FormFeedback type="invalid">
                            {validation.errors.emailType}
                          </FormFeedback>
                        ) : null}
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Subject *
                        </Label>
                        <Input
                          type="text"
                          className="form-control"
                          name="subject"
                          id="horizontal-email-Input"
                          placeholder="Enter Email Subject "
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.subject || ""}
                          invalid={
                            validation.touched.subject &&
                              validation.errors.subject
                              ? true
                              : false
                          }
                        />
                        {validation.touched.subject &&
                          validation.errors.subject ? (
                          <FormFeedback type="invalid">
                            {validation.errors.subject}
                          </FormFeedback>
                        ) : null}
                      </Col>
                    </Row>
                    <Row>
                      <Col sm={12} >
                        <Label
                          htmlFor="horizontal-email-Input"
                          className="col-sm-3 col-form-label"
                        >
                          Email Body *
                        </Label>
                        <JoditEditor
                            ref={editor}
                            value={emailBody}
                            config={config}
                            onBlur={newContent => setEmailBody(newContent)}
                          />
                        {editorError && (<div className="error">{editorError}</div>)}

                      </Col>

                    </Row>
                    <Row>
                      <Col>
                        <div className="text-end" style={{ margin: "20px 0px 0px 0px" }}>
                          <button
                            type="submit"
                            className="btn btn-outline-success"
                            onClick={() => {
                              navigateBack();
                            }
                            }
                          >
                            Back
                          </button>
                          <button
                            type="submit"
                            className="btn btn-success save-customer"
                            style={{ marginLeft: "7px" }}
                          >
                            Save
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </form>}
                  {showViewTemplate && <div>
                    <Row className="mb-4">
                      <Col sm={6}>
                        <Label
                          className="col-sm-3 col-form-label label"
                        >
                          Type *
                        </Label>
                        <p className="fs-5">{templateList.emailType || "-"}</p>
                      </Col>
                      <Col sm={6}>
                        <Label
                          htmlFor="horizontal-notification-Input"
                          className="col-sm-3 col-form-label label"
                        >
                          Subject *
                        </Label>
                        <p className="fs-5">{templateList.subject || "-"}</p>
                      </Col>
                    </Row>
                    <Row className="mb-4">
                      <Col sm={12}>
                        <Label
                          className="col-sm-6 col-form-label label"
                        >
                          Email Body*
                        </Label>
                        <JoditEditor
                         value={templateList.emailBody} 
                         config={{
                         readonly: true,
                         removeButtons: ['about'],
                         showCharsCounter: false,
                         showWordsCounter: false,
                         showXPathInStatusbar: false,
                         }}
                        />

                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <div>
                          <button
                            className="btn btn-outline-success"
                            onClick={() => {
                              navigateBack()
                            }}
                          >
                            Back
                          </button>
                        </div>
                      </Col>
                    </Row>
                  </div>}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      {showCommonDialog &&
        <CommonDialog isShow={showCommonDialog.isShow} message={showCommonDialog.message} data={showCommonDialog.data} postitiveBtn={'Submit'} negativeBtn={'Close'} onCloseFn={dialogAction}></CommonDialog>
      }
    </React.Fragment>
  )
}

AddEmailTemplate.propTypes = {
  history: PropTypes.object,
}

export default AddEmailTemplate
